import { useContext, useState, useEffect, useCallback } from 'react';
import { ThreeJsMultiplexedCanvasContext } from '../components/ThreeJsMultiplexedCanvasProvider';

const useMultiplexedThreeJs = (opts = {}) => {
  const { debug = false } = opts;

  const [canvas, setCanvas] = useState(null);
  const { addThreeJsCanvas, removeThreeJsCanvas, renderer } = useContext(
    ThreeJsMultiplexedCanvasContext
  );

  const handleCanvasRef = useCallback((canvasEl) => {
    setCanvas(canvasEl);
  }, []);

  const onThreeJsCanvasReady = (fn, state = []) =>
    useEffect(() => {
      if (!canvas || !addThreeJsCanvas) {
        return;
      }

      if (debug) {
        console.info(
          '[DEBUG] Creating new render fn for multiplexed canvas: ',
          canvas
        );
      }

      const cleanUpFn = fn({
        renderer,
        canvas,
        addThreeJsCanvas,
        renderMultiplexedThreeJsScene: (fn) => {
          addThreeJsCanvas(canvas, fn);
        },
      });

      return () => {
        if (debug) {
          console.info(
            '[DEBUG] Cleaning up & updating render fn for canvas: ',
            canvas
          );
        }

        if (typeof cleanUpFn === 'function') {
          cleanUpFn();
        }

        removeThreeJsCanvas(canvas);
      };
    }, [canvas, addThreeJsCanvas, removeThreeJsCanvas, ...state]);

  return {
    onThreeJsCanvasReady,
    handleCanvasRef,
    canvas,
    renderer,
  };
};

export default useMultiplexedThreeJs;
